var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4034 4.85498C10.3079 4.86453 10.212 4.86949 10.1161 4.86992C9.0638 4.87006 8.08232 4.32537 7.50593 3.42131V8.35415C7.50593 10.3677 5.91637 12 3.95551 12C1.99466 12 0.405029 10.3677 0.405029 8.35422C0.405029 6.34073 1.99459 4.70837 3.95544 4.70837C4.02959 4.70837 4.10199 4.7152 4.17488 4.71994V6.51657C4.10199 6.50759 4.03043 6.49395 3.95544 6.49395C2.95466 6.49395 2.14337 7.32704 2.14337 8.35472C2.14337 9.38241 2.95466 10.2155 3.95544 10.2155C4.95623 10.2155 5.84033 9.40568 5.84033 8.37785L5.85782 0H7.53167C7.68948 1.54135 8.89983 2.74531 10.405 2.8583V4.85505",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d6cac3bea8c5fc0fb70b55c88f542d39.svg";
export { ForwardRef as ReactComponent };